import { render, staticRenderFns } from "./videoControl.vue?vue&type=template&id=11b7374d&scoped=true"
import script from "./videoControl.vue?vue&type=script&lang=js"
export * from "./videoControl.vue?vue&type=script&lang=js"
import style0 from "./videoControl.vue?vue&type=style&index=0&id=11b7374d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b7374d",
  null
  
)

export default component.exports